import React from 'react';

const BrandingTab = ({
  brandingForm,
  setBrandingForm,
  loading,
  handleUpdateBranding,
  handleUploadHeaderImage,
  handleDeleteHeaderImage,
  handleUploadFooterImage,
  handleDeleteFooterImage,
  getImageUrl,
}) => {
  return (
    <div className="card">
      <h2 className="text-xl font-bold mb-4">Configuracion de Branding</h2>
      <form onSubmit={handleUpdateBranding} className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="label">Color Primario</label>
            <div className="flex items-center space-x-2">
              <input
                type="color"
                value={brandingForm.primaryColor}
                onChange={(e) => setBrandingForm({...brandingForm, primaryColor: e.target.value})}
                className="h-10 w-20"
              />
              <input
                type="text"
                value={brandingForm.primaryColor}
                onChange={(e) => setBrandingForm({...brandingForm, primaryColor: e.target.value})}
                className="input-field flex-1"
              />
            </div>
          </div>

          <div>
            <label className="label">Color Secundario</label>
            <div className="flex items-center space-x-2">
              <input
                type="color"
                value={brandingForm.secondaryColor}
                onChange={(e) => setBrandingForm({...brandingForm, secondaryColor: e.target.value})}
                className="h-10 w-20"
              />
              <input
                type="text"
                value={brandingForm.secondaryColor}
                onChange={(e) => setBrandingForm({...brandingForm, secondaryColor: e.target.value})}
                className="input-field flex-1"
              />
            </div>
          </div>

          <div>
            <label className="label">Color de Fondo</label>
            <div className="flex items-center space-x-2">
              <input
                type="color"
                value={brandingForm.backgroundColor}
                onChange={(e) => setBrandingForm({...brandingForm, backgroundColor: e.target.value})}
                className="h-10 w-20"
              />
              <input
                type="text"
                value={brandingForm.backgroundColor}
                onChange={(e) => setBrandingForm({...brandingForm, backgroundColor: e.target.value})}
                className="input-field flex-1"
              />
            </div>
          </div>

          <div>
            <label className="label">Color de Texto</label>
            <div className="flex items-center space-x-2">
              <input
                type="color"
                value={brandingForm.textColor}
                onChange={(e) => setBrandingForm({...brandingForm, textColor: e.target.value})}
                className="h-10 w-20"
              />
              <input
                type="text"
                value={brandingForm.textColor}
                onChange={(e) => setBrandingForm({...brandingForm, textColor: e.target.value})}
                className="input-field flex-1"
              />
            </div>
          </div>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="btn-primary"
        >
          {loading ? 'Guardando...' : 'Guardar Configuracion de Colores'}
        </button>
      </form>

      <hr className="my-8" />

      {/* Sección de imágenes */}
      <div className="space-y-6">
        <h3 className="text-lg font-semibold">Imagenes de Branding</h3>

        {/* Header Image */}
        <div>
          <label className="label">Imagen de Encabezado</label>
          <p className="text-sm text-gray-500 mb-2">Imagen que aparecera en la parte superior del formulario de registro</p>

          {brandingForm.headerImageUrl ? (
            <div className="space-y-2">
              <div className="relative inline-block">
                <img
                  src={getImageUrl(brandingForm.headerImageUrl)}
                  alt="Header"
                  className="max-h-32 border rounded"
                />
              </div>
              <div className="flex space-x-2">
                <label className="btn-secondary cursor-pointer">
                  Cambiar Imagen
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleUploadHeaderImage}
                    className="hidden"
                    disabled={loading}
                  />
                </label>
                <button
                  type="button"
                  onClick={handleDeleteHeaderImage}
                  disabled={loading}
                  className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition disabled:opacity-50"
                >
                  Eliminar
                </button>
              </div>
            </div>
          ) : (
            <label className="btn-primary cursor-pointer inline-block">
              Subir Imagen de Encabezado
              <input
                type="file"
                accept="image/*"
                onChange={handleUploadHeaderImage}
                className="hidden"
                disabled={loading}
              />
            </label>
          )}
        </div>

        {/* Footer Image */}
        <div>
          <label className="label">Imagen de Pie de Pagina</label>
          <p className="text-sm text-gray-500 mb-2">Imagen que aparecera en la parte inferior del formulario de registro</p>

          {brandingForm.footerImageUrl ? (
            <div className="space-y-2">
              <div className="relative inline-block">
                <img
                  src={getImageUrl(brandingForm.footerImageUrl)}
                  alt="Footer"
                  className="max-h-32 border rounded"
                />
              </div>
              <div className="flex space-x-2">
                <label className="btn-secondary cursor-pointer">
                  Cambiar Imagen
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleUploadFooterImage}
                    className="hidden"
                    disabled={loading}
                  />
                </label>
                <button
                  type="button"
                  onClick={handleDeleteFooterImage}
                  disabled={loading}
                  className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition disabled:opacity-50"
                >
                  Eliminar
                </button>
              </div>
            </div>
          ) : (
            <label className="btn-primary cursor-pointer inline-block">
              Subir Imagen de Pie de Pagina
              <input
                type="file"
                accept="image/*"
                onChange={handleUploadFooterImage}
                className="hidden"
                disabled={loading}
              />
            </label>
          )}
        </div>
      </div>
    </div>
  );
};

export default BrandingTab;
